export default "__VITE_PUBLIC_ASSET__db1514e1__"